import request from "../request";

/** 当前登录用户权限码（与 JWT 会话内 Authorities 中非 ROLE_* 一致） */
export function getMyPermissions() {
  return request.get("/api/me/permissions");
}
